export default __webpack_public_path__ + "static/ga-5044bb1c320b4ca8cb01f601ca849395.png";